import type { JSX, SVGProps } from "react";

/**
 * Lined direct/open glyph (24x24 viewBox). Fill uses `currentColor`.
 */
export function DirectLinedIcon(props: SVGProps<SVGSVGElement>): JSX.Element {
  "use memo";
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden
      data-nexight-chrome-glyph="fill"
      data-tutti-chrome-glyph="fill"
      {...props}
    >
      <path
        fill="currentColor"
        d="M11 2C11.5523 2 12 2.44772 12 3C12 3.55228 11.5523 4 11 4H5C4.73478 4 4.4805 4.10543 4.29297 4.29297C4.10543 4.4805 4 4.73478 4 5V19C4 19.2652 4.10543 19.5195 4.29297 19.707C4.48051 19.8946 4.73478 20 5 20H19C19.2652 20 19.5195 19.8946 19.707 19.707C19.8946 19.5195 20 19.2652 20 19V13C20 12.4477 20.4477 12 21 12C21.5523 12 22 12.4477 22 13V19C22 19.7957 21.6837 20.5585 21.1211 21.1211C20.5585 21.6837 19.7957 22 19 22H5C4.20435 22 3.44152 21.6837 2.87891 21.1211C2.3163 20.5585 2 19.7957 2 19V5C2 4.20435 2.3163 3.44152 2.87891 2.87891C3.44152 2.3163 4.20435 2 5 2H11ZM21 2C21.0563 2 21.1113 2.00571 21.165 2.01465C21.1738 2.01611 21.1827 2.01686 21.1914 2.01855L21.2012 2.02051C21.211 2.02252 21.2207 2.02504 21.2305 2.02734C21.251 2.0322 21.2717 2.0368 21.292 2.04297C21.3408 2.05783 21.3873 2.0778 21.4326 2.09961C21.4466 2.10634 21.4609 2.11269 21.4746 2.12012C21.6203 2.19887 21.7441 2.31255 21.835 2.4502C21.8597 2.48768 21.8812 2.52662 21.9004 2.56641C21.9222 2.61159 21.9412 2.65838 21.9561 2.70703C21.9623 2.72732 21.9668 2.74799 21.9717 2.76855C21.9893 2.84294 22 2.92022 22 3V9C22 9.55228 21.5523 10 21 10C20.4477 10 20 9.55228 20 9V5.41406L12.707 12.707C12.3165 13.0976 11.6835 13.0976 11.293 12.707C10.9024 12.3165 10.9024 11.6835 11.293 11.293L18.5859 4H15C14.4477 4 14 3.55228 14 3C14 2.44772 14.4477 2 15 2H21Z"
      />
    </svg>
  );
}
